<template>

		<div class="list--view">
            <div class="single--list-view single--list-view-recruitingapplicants">
                <vs-select
                    class="selectExample"
                    v-model="selectTypeRecruitingApplicants"
                    @input="statusSelected"
                >
                    <vs-select-item
                        :is-selected="item.isSelected"
                        :key="index"
                        :value="item.value"
                        :text="item.label"
                        v-for="(item,index) in optionsTypeRecruitingApplicants" />
                </vs-select>
            </div>
            <!-- Commented since status card were added -->
            <!-- <div class="single--list-view single--list-view-roles">
                <vs-select
                    class="selectExample"
                    v-model="selectStatusIdRecruitingApplicants"
                    @input="statusIdSelected"
                >
                    <vs-select-item
                        :is-selected="item.isSelected"
                        :key="index"
                        :value="item.value"
                        :text="item.label"
                        v-for="(item,index) in selectStatusIdRecruitingApplicants" />
                </vs-select>
            </div> -->
        </div>
</template>

<script>
    export default {
        data () {
            return {
                selectTypeRecruitingApplicants: (location.search.indexOf("archived_at") >= 0 && /archived_at=([^&]+)/.exec(location.href)[1] === "true") ? "hystorical" : "actual",
                optionsTypeRecruitingApplicants:[
                    {value: 'actual', label:this.__('misc.actuals'), isSelected: false },
                    {value: 'hystorical', label:this.__('misc.history'), isSelected: false },
                ],
                selectStatusIdRecruitingApplicants: [],
            }
        },
        methods: {
            statusSelected(selectedOption, id) {
                if (selectedOption == "actual") {
                    location.href = app.__vue__.addParam("archived_at", "false");
                } else if (selectedOption == "hystorical") {
                    location.href = app.__vue__.addParam("archived_at", "true");
                }
            },
            statusIdSelected(selectedOption, id) {
                if(selectedOption===''){
                    location.href = "/recruiting-applicants";
                }
                else {
                    location.href = app.__vue__.addParam('status_id', selectedOption);
                }
            },
            loadStatuses(){
                axios
                    .get("/getRecruitingApplicantStatuses")
                    .then(response => {
                       this.selectStatusIdRecruitingApplicants=response.data;
                    });
            },
        },
        mounted() {
            this.loadStatuses();
        }

    }
</script>
